import React from 'react';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { AppBar, IconButton, makeStyles } from '@material-ui/core';
import { ArrowBackIos } from '@material-ui/icons';
import GnbCheckerBoardMenu from '@routes/Common/CommonLayout/GnbCheckerBoardMenu';

export const useStyles = makeStyles(() => ({
  appBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: (hasTitle) => (hasTitle ? '0px 16px 0px 0px' : '0px 16px'),
    height: (hasTitle) => (hasTitle ? 49 : 68),
    backgroundColor: colorSet.gray000,
    borderBottom: `1px solid ${colorSet.gray400}`,
    '& .MuiSvgIcon-root': {
      color: colorSet.gray900,
      cursor: 'pointer'
    }
  },
  switchAccountHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: colorSet.primary500,
    height: 48,
    width: '100vw',
    padding: '0px 16px',
    '& > p': {
      color: colorSet.gray000
    }
  },
  logo: {
    cursor: 'pointer',
    height: 18,
    width: 140
  },
  backButton: {
    '& svg': {
      transform: 'translateX(5px)'
    }
  },
  title: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
  }
}));

interface Props {
  title?: string;
  urlParam?: string;
  onClickBack?: () => void;
}

const AccountHeader: React.FC<Props> = ({ title, urlParam, onClickBack }) => {
  const classes = useStyles(!!title);

  return (
    <>
      <AppBar elevation={0} position="sticky" className={classes.appBar}>
        {!urlParam ? (
          <>
            <CustomizedTypography
              variant="h4"
              fontWeight="700"
              color="textPrimary"
            >
              더보기
            </CustomizedTypography>
            <GnbCheckerBoardMenu />
          </>
        ) : (
          <>
            <IconButton className={classes.backButton} onClick={onClickBack}>
              <ArrowBackIos />
            </IconButton>
            <CustomizedTypography
              className={classes.title}
              variant="body1"
              fontWeight="500"
              color="textPrimary"
            >
              {title}
            </CustomizedTypography>
          </>
        )}
      </AppBar>
    </>
  );
};

export default AccountHeader;
